class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

this.querySelector('.cart-notification__close')?.addEventListener('click', this.close.bind(this));

this.querySelector('.cart-notification__links > button[type="button"]')?.addEventListener(
  'click',
  this.close.bind(this)
);
const checkoutButton = this.querySelector('#gs-cart-notification-checkout');
const consentModal = this.querySelector('#gs-digital-consent-modal');
const consentCheckbox = this.querySelector('#gs-digital-consent-modal-checkbox');
const consentContinue = this.querySelector('#gs-digital-consent-modal-continue');
const consentCancel = this.querySelector('#gs-digital-consent-modal-cancel');
const checkoutForm = this.querySelector('#cart-notification-form');

checkoutButton?.addEventListener('click', (event) => {
  if (!this.hasDigitalItem || this.digitalConsentGranted) return;

  event.preventDefault();

  consentCheckbox.checked = false;
  consentContinue.disabled = true;
  consentModal.hidden = false;
});

consentCheckbox?.addEventListener('change', () => {
  consentContinue.disabled = !consentCheckbox.checked;
});

consentCancel?.addEventListener('click', () => {
  consentModal.hidden = true;
});

consentContinue?.addEventListener('click', () => {
  if (!consentCheckbox.checked || !checkoutForm || !checkoutButton) return;

  let consentInput = checkoutForm.querySelector(
    'input[name="attributes[Digital Content Consent]"]'
  );

  if (!consentInput) {
    consentInput = document.createElement('input');
    consentInput.type = 'hidden';
    consentInput.name = 'attributes[Digital Content Consent]';
    checkoutForm.appendChild(consentInput);
  }

  consentInput.value = 'Yes';

  this.digitalConsentGranted = true;
  checkoutButton.setAttribute('name', 'checkout');
  consentModal.hidden = true;

  checkoutForm.requestSubmit(checkoutButton);
});
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
        });

    this.updateDigitalCheckoutState();

    if (this.header) this.header.reveal();
    this.open();
  }

  async updateDigitalCheckoutState() {
  const checkoutButton = this.querySelector('#gs-cart-notification-checkout');

  if (!checkoutButton) return;

  checkoutButton.disabled = true;

  try {
    const response = await fetch(routes.cart_url);
    const html = await response.text();
    const cartDocument = new DOMParser().parseFromString(html, 'text/html');

    const hasDigitalItem = cartDocument.querySelector('#gs-digital-consent');

this.hasDigitalItem = !!hasDigitalItem;

if (this.hasDigitalItem) {
  checkoutButton.removeAttribute('name');
} else {
  checkoutButton.setAttribute('name', 'checkout');
}
  } catch (error) {
    checkoutButton.removeAttribute('name');
  } finally {
    checkoutButton.disabled = false;
  }
}

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
